import Axios from "axios";
import {
    SET_LEAVE_SUMMARY_REPORT_LIST, 
    UNSET_LEAVE_SUMMARY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getleaveSummaryReport,
} from "@/store/api";

const state = {
    getLeaveSummaryReport: [],
};

const getters = {
    getLeaveSummaryReport(state) {
        return state.getLeaveSummaryReport;
    },
};

const mutations = {
    [SET_LEAVE_SUMMARY_REPORT_LIST](state, data) {
        state.getLeaveSummaryReport = data;
    },
    [UNSET_LEAVE_SUMMARY_REPORT_LIST](state) {
        state.getLeaveSummaryReport = [];
    },
};

const actions = {

    getLeaveSummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getleaveSummaryReport}`, { params: data })
                .then((response) => {
                    commit(SET_LEAVE_SUMMARY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_LEAVE_SUMMARY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
  state,
  getters,
  actions,
  mutations,
};